import { styled } from 'styled-components';
import { Card, Space } from 'antd';
import Title from 'antd/es/typography/Title';

export const TitleContainer = styled.div`
  width: 400px;
  text-align: center;
  margin-bottom: 32px;
`;

export const MicrophoneIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: rgb(224 231 255);
  color: rgb(79 70 229);
  margin-bottom: 16px;
`;

export const ServiceName = styled(Title).attrs({ level: 2 })`
  text-align: center;
`;

export const ServiceSubtitle = styled.div`
  text-align: center;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.65);
`;

export const LoginContainer = styled.main`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
`;

export const LoginCard = styled(Card)`
  width: 500px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

export const FullWidthSpace = styled(Space)`
  width: 100%;
`;
